var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{ref:"item",class:{
    '[ is-active ]': _vm.isActive,
    '[ is-left ]': _vm.isLeft,
    '[ is-right ]': !_vm.isLeft && !_vm.isActive,
    '[ is-animating ]': _vm.isAnimating }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }